import PropTypes from 'prop-types';
import React from 'react';
import { useChannelIsMuted } from '../../../Slice';
import { IconBell, IconMuted } from '../../rootAccess';
import { handleMuteChannel } from '../../utils';
import { ActionButton } from '../ActionButton';

export function ChannelMuteStatus({ channelId, isLabelNeeded = true, defaultRender = true }) {
   const isMuted = useChannelIsMuted(channelId);

   const toggleMute = () => {
      handleMuteChannel({ channelId, action: isMuted ? 0 : 1 });
   };

   let label = '';
   if (isLabelNeeded) {
      if (isMuted) {
         label = 'Unmute';
      } else {
         label = 'Mute';
      }
   }

   if (!defaultRender) {
      return isMuted ? <IconMuted style={{ minWidth: '18px' }} /> : null;
   }

   return <ActionButton icon={isMuted ? <IconMuted style={{ minWidth: '18px' }} /> : <IconBell style={{ minWidth: '18px' }} />} label={label} onClick={toggleMute} />;
}

ChannelMuteStatus.propTypes = {
   channelId: PropTypes.string,
   isLabelNeeded: PropTypes.bool,
   defaultRender: PropTypes.bool,
};
